import { ExceptionReporter } from '@vestico/shared';

import { AppContext } from './AppContext';
import { Configurations } from './model/api';

export interface Props {
  root: HTMLElement;
  config: Configurations;
}

export const App = ({ root, config }: Props) => {
  return (
    <ExceptionReporter provider={config.clientId}>
      <AppContext rootElement={root} appConfig={config} />
    </ExceptionReporter>
  );
};
